import {
  Id,
  PinnedMessagesData,
  MessagesResponse as Response,
  convertPinnedMessages,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'

export function usePinnedMessages<T = PinnedMessagesData>(
  id: Id,
  enabled = true
) {
  const { server } = useServer()

  return useQuery<PinnedMessagesData, unknown, T>({
    queryKey: keys.pinnedMessages(id),
    queryFn: fetchPinnedMessages,
    enabled: !!id && enabled,
  })

  async function fetchPinnedMessages() {
    const response = await server.get<Response.PinnedMessageResponse>(
      `/v2/chat/conversations/${id}/pinned`
    )
    return {
      pinnedMessages: convertPinnedMessages(response),
    }
  }
}
